let lang = document.location.pathname.substr( 1, 2 ),
language,
appLanguage,
env;

switch( lang ){
    case 'jp':
    case 'ja':
        language = 'ja';
        appLanguage = 'jp'
        break;
    case 'cn':
    case 'zh':
        language = 'zh';
        appLanguage = 'cn';
        break;
    case 'ru':
    case 'en': 
        language = appLanguage = lang;
        break;
    default: 
        language = appLanguage = 'en';
        break;
}

const hostname = document.location.hostname.replace( /^(.*?)\..*?$/g, '$1' );

// determine environment
if( hostname.includes( '-dev' ) ){
    env = 'development';
} else if( hostname.includes( '-qa' ) ) {
    env = 'qa';
} else if( hostname.includes( 'localhost' ) || hostname.includes( '127.0.0.1' ) ){
    env = 'local';
} else {
    env = 'production';
}

/**
 * @name LANGUAGE
 * @constant
 * @description Actual language code used inside the app
 */
export const LANGUAGE = language;

/**
 * @name APP_LANGUAGE
 * @constant
 * @description Language code used by end points
 */
export const APP_LANGUAGE = appLanguage;

/**
 * @name ENVIRONMENT
 * @constant
 * @description Determines the environment of the application. (i.e. development, production, qa, etc.)
 */
export const ENVIRONMENT = env;

/**
 * @name HOST
 * @constant
 * @description The base URL
 */
export const HOST = `https://${ ENVIRONMENT !== 'local' ? window.location.host : 'www-dev2.cldnet.analog.com' }`;
